import type { StackProps } from '@mui/material';
import {
  Section,
  NameBanner,
  CustomizedAccordion,
} from '@rumblefish/ui/Rumblefish23Theme';
import parse from 'html-react-parser';

import { AccordionData, benefitsData } from './BenefitsData';
import {
  MainText,
  StyledStack,
  DescriptionText,
  StyledTextStack,
  StyledContentStack,
  StyledAccordionStack,
} from './styles';

export const Benefits = ({ ...props }: StackProps): React.ReactElement => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner
          type="section"
          text="What are the benefits?"
          color="magenta"
        />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">
              {parse(benefitsData.mainText)}
            </MainText>
            <DescriptionText variant="strong_400">
              {benefitsData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion data={AccordionData()} />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
